import { DateTime } from "luxon";
import posthog from "posthog-js";
import React, { FC } from "react";

import { Avatar, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import LoadingScreen from "../../../components/LoadingScreen";
import {
  useAcceptInvitationMutation,
  useListUserInvitationsQuery,
  useRejectInvitationMutation,
} from "../../../store/pomeriumApi";

const List: FC = () => {
  const [accept] = useAcceptInvitationMutation();
  const [reject] = useRejectInvitationMutation();

  const {
    data: invites,
    isLoading,
    isFetching,
  } = useListUserInvitationsQuery();

  const accepted = (inviteID: string) => () => {
    accept(inviteID);
    posthog.capture("invitation_accepted", { inviteID });
  };
  const rejected = (inviteID: string) => () => {
    reject(inviteID);
    posthog.capture("invitation_rejected", { inviteID });
  };

  if (isLoading || isFetching) {
    return <LoadingScreen />;
  }

  return (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Inviter</TableCell>
          <TableCell>Invite Date</TableCell>
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableBody>
      <TableBody>
        {!invites?.length && (
          <TableRow>
            <TableCell colSpan={4} align="center">
              Currently No Invites
            </TableCell>
          </TableRow>
        )}
        {invites?.map((invite) => (
          <TableRow
            key={"invite_" + invite.id}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <TableCell component="th" scope="row">
              {
                <Stack direction="row" alignItems="center">
                  <Avatar
                    sx={{ width: 24, height: 24 }}
                    src={invite.organization?.logoURL || ""}
                    variant="circular"
                  />
                  <Typography sx={{ ml: 1 }}>
                    {invite.organization?.name}
                  </Typography>
                </Stack>
              }
            </TableCell>
            <TableCell>
              {
                <Stack direction="row" alignItems="center">
                  <Avatar
                    src={invite.invitedBy?.photoUrl || ""}
                    variant="circular"
                    sx={{ width: 24, height: 24 }}
                  />
                  <Typography sx={{ ml: 1 }}>
                    {invite.invitedBy?.displayName}
                  </Typography>
                </Stack>
              }
            </TableCell>
            <TableCell>
              {DateTime.fromISO(invite.createdAt).toLocaleString()}
            </TableCell>

            <TableCell>
              <Stack direction="row">
                <Button
                  key={"accept" + invite.id}
                  color="primary"
                  onClick={accepted(invite.id as string)}
                >
                  Accept
                </Button>
                <Divider
                  key={"divider" + invite.id}
                  orientation="vertical"
                  flexItem
                />
                <Button
                  key={"reject" + invite.id}
                  color="error"
                  onClick={rejected(invite.id as string)}
                >
                  Reject
                </Button>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
export default List;
